import { Component } from "@angular/core";
import { UiMenuItemDirective } from "@webapp/ui/menu/directives/menu-item.directive";
@Component({
  selector: "gh-example-menu-component",
  templateUrl: "./example-menu.component.html",
  styleUrls: ["./example-menu.component.less"],
})
export class ExampleMenuComponent {
  public toggleTheme: boolean;
  public mode: boolean;

  public clickOnItem(menuItem: UiMenuItemDirective): void {
    // eslint-disable-next-line no-console
    console.log(menuItem.nzSelected);
  }

  public clickOnSubmenu(value): void {
    // eslint-disable-next-line no-console
    console.log(value);
  }
}
